// extracted by mini-css-extract-plugin
export default {"pan":"info_pan__Hopzt","b":"info_b__1pxz+"};